import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CreateDiscountCommand } from 'src/app/core/api/models';
import { DiscountService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { RegularExpressions } from 'src/app/core/constants/regular-expressions';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { PeriodicDateTimeConfig } from 'src/app/shared/components/periodic-date-time-picker/periodic-date-time-picker.component';
import { GetDiscountByIdDto } from './../../../../core/api/models/get-discount-by-id-dto';
import { UpdateDiscountCommand } from './../../../../core/api/models/update-discount-command';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
    selector: 'app-discount-form',
    templateUrl: './discount-form.component.html',
    styleUrls: ['./discount-form.component.scss'],
    imports: [BaseFormModule]
})
export class DiscountFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<GetDiscountByIdDto> = {};
  model: CreateDiscountCommand = {};
  protected currentService = inject(DiscountService);
  periodicDateTimeConfig: PeriodicDateTimeConfig;

  //#endregion

  constructor() {
    super();
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
      this.setPeriodicDateTimeConfig();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  initModel() {
    try {
      super.initModel();
      this.onChangeIsPercentage(this.formPageConfig.isEditMode);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  setPeriodicDateTimeConfig() {
    try {
      this.periodicDateTimeConfig = {
        startDateLabel: 'common.startDate',
        startTimeLabel: 'common.startTime',
        endDateLabel: 'common.expireDate',
        endTimeLabel: 'common.expireTime',
        startDateFormControl: this.form?.get('dateStart') as FormControl,
        startTimeFormControl: this.form?.get('startTime') as FormControl,
        endDateFormControl: this.form?.get('dateExpire') as FormControl,
        endTimeFormControl: this.form?.get('expireTime') as FormControl,
        isEditMode: this.formPageConfig.isEditMode,
        responsiveClassName: 'sm:tw-w-1/2 xl:tw-w-1/3 xl:tw-w-1/4',
        minStartDateType: 'today',
      };

      if (this.formPageConfig.isEditMode) {
        this.periodicDateTimeConfig.startDateTimeValue = this.model.dateStart;
        this.periodicDateTimeConfig.endDateTimeValue = this.model.dateExpire;
        this.periodicDateTimeConfig = Object.assign(
          {},
          this.periodicDateTimeConfig
        );
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      discountType: new FormControl('', Validators.required),
      discountCode: new FormControl('', Validators.required),
      isPercentage: new FormControl('', Validators.maxLength[3]),
      discountPercentageValue: new FormControl(''),
      discountValue: new FormControl(),
      maximumAmount: new FormControl(''),
      maximumUse: new FormControl('', Validators.required),
      specialOrganization: new FormControl(''),
      dateStart: new FormControl('', Validators.required),
      dateExpire: new FormControl('', Validators.required),
      startTime: new FormControl('', Validators.required),
      expireTime: new FormControl('', Validators.required),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateDiscountCommand) {
    this.loading = true;

    this.currentService
      .discountCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateDiscountCommand) {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .discountUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onChangeIsPercentage(isEditMode?: boolean) {
    try {
      this.form.get('discountValue').clearValidators();
      this.form.get('discountPercentageValue').clearValidators();

      if (this.model.isPercentage) {
        this.form
          .get('discountPercentageValue')
          .setValidators([
            Validators.required,
            Validators.pattern(RegularExpressions.floatNumbers),
          ]);
        this.form
          .get('maximumAmount')
          .setValidators([Validators.required, Validators.min(1)]);

        if (
          !this.formPageConfig.isEditMode ||
          !this.formPageConfig.editData.isPercentage
        )
          this.model.maximumAmount = null;
      } else {
        this.form.get('discountValue').setValidators([Validators.required]);
        this.form.get('maximumAmount').clearValidators();
      }

      if (!isEditMode) this.model.discountValue = 1;

      this.form.get('discountValue').updateValueAndValidity();
      this.form.get('discountPercentageValue').updateValueAndValidity();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }
}
